export enum SearchListType {
  Gateway = 'Gateway',
  Boiler = 'Boiler',
  User = 'User',
  Location = 'location',
  Error = 'Error',
}

export interface SearchHistoryItem {
  type: SearchListType;
  searchParams: any;
  timestamp: string;
}

export enum SearchType {
  gateway,
  boiler,
  user,
  error,
  gatewayInvitations,
  installationsToMigrate,
}
